module.exports = __webpack_public_path__ + "src/assets/images/logos/paxia//paxia-logo-color.svg";